import { render, staticRenderFns } from "./V2OrderDetail.vue?vue&type=template&id=0ef558a6&scoped=true&"
import script from "./V2OrderDetail.vue?vue&type=script&lang=js&"
export * from "./V2OrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./V2OrderDetail.vue?vue&type=style&index=0&id=0ef558a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef558a6",
  null
  
)

export default component.exports